import { Button } from "@mui/material";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isLoading: boolean;
  onClick: () => void;
};

export const RevertTransactionButton = ({ isLoading, onClick }: Props) => {
  const { t } = useResource();

  return (
    <Button
      variant="outlined"
      color="primary"
      fullWidth
      sx={{
        height: "60px",
        "& .MuiButton-startIcon svg": { fontSize: 24 },
      }}
      onClick={onClick}
      disabled={isLoading}
      startIcon={isLoading ? undefined : <MultipleStopIcon />}
    >
      {isLoading
        ? t(Resources.Dashboard.Loading)
        : t(Resources.Transactions.RefundTransaction)}
    </Button>
  );
};
